module.exports = __webpack_public_path__ + "img/unisul.29f566d2.svg";